import type { ActivationChecklist } from "./firebase-function-types";

export const dispatchActivationProgressEvent = (step: ActivationChecklist) => {
    document.dispatchEvent(new CustomEvent("activation-progress", { detail: { step } }));
};
